export default {
  systemSettings: {
    menu_text_color: '',
    primary_color: '',
    secundary_color: '',
    logo: '',
    logoAuth: ''
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/store/state.js